export default __webpack_public_path__ + "static/media/checkbox.dad5918c.svg";